import React from "react";
import { Reveal } from "@/components/common/Reveal";

/**
 * Shared layout for legal pages (Privacy, Terms).
 */
export const LegalLayout = ({ title, updated, children }) => {
  return (
    <>
      <section className="et-navy-band relative overflow-hidden">
        <div className="absolute inset-0 et-dot-grid opacity-[0.15]" />
        <div className="et-container relative py-14 lg:py-16">
          <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-white">{title}</h1>
          {updated && <p className="mt-3 text-sm text-slate-300">{updated}</p>}
        </div>
      </section>
      <section className="et-section">
        <div className="et-container max-w-3xl">
          <Reveal>
            <div className="legal-prose space-y-4 text-slate-600 leading-relaxed">
              {children}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
};
